export const cleanUserTokensFromLocalStorage = () => {
  localStorage.removeItem("accessToken");
  localStorage.removeItem("refreshToken");
};

export const setUserTokensToLocalStorage = (
  accessToken: string,
  refreshToken: string,
) => {
  localStorage.setItem("accessToken", accessToken);
  localStorage.setItem("refreshToken", refreshToken);
};

const storedToken = (key: string) => {
  const value = localStorage.getItem(key);
  return value && value !== "undefined" && value !== "null" ? value : null;
};
export const getAccessToken = () => storedToken("accessToken");
export const getRefreshToken = () => storedToken("refreshToken");
